import { useMutation } from 'react-query';

import { axios } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { showNotification } from '@/utils/notificationUtils';
export type FileDetails = {
  fileName: string;
  fileSize: string;
  fileUrl: string;
};

export type requestDTO = {
  data: {
    id?:number;
    petId?:number;
    rabies: boolean;
    rabiesExpiry: string;
    rabiesTaken: string;
    rabiesRecord?: FileDetails | null
    dhlpp: boolean;
    dhlppExpiry: string;
    dhlppTaken: string;
    dhlppRecord?: FileDetails | null
    bordetella: boolean;
    bordetellaExpiry: string;
    bordetellaTaken: string;
    bordetellaRecord?: FileDetails | null
    canine:boolean;
    canineExpiry: string;
    canineTaken: string;
    canineRecord?: FileDetails | null

  };
};
export type getResponse = {
    id:string;
    petId:string;
    rabies: boolean;
    rabiesExpiry: string;
    rabiesTaken: string;
    rabiesRecord?: FileDetails;
    dhlpp: boolean;
    dhlppExpiry: string;
    dhlppTaken: string;
    dhlppRecord?: FileDetails;
    bordetella: boolean;
    bordetellaExpiry: string;
    bordetellaTaken: string;
    bordetellaRecord?: FileDetails;
    canine:boolean;
    canineTaken: string;
    canineExpiry: string;
    canineRecord?: FileDetails;
};
export type getRequest = {
  data: {
    petId:number;
  };
};

export const addPetVaccination = ({ data }: requestDTO): Promise<getResponse> => {
  return axios.post(`parent/pet-vaccination/add`, data);
};

type UseUpdateBusinessOptions = {
  config?: MutationConfig<typeof addPetVaccination>;
};

export const useAddPetVaccination = ({ config }: UseUpdateBusinessOptions = {}) => {
  return useMutation({
    onSuccess: () => {
      showNotification({
        type: 'success',
        title: 'Pet vaccination added successfully',
      });
    },
    ...config,
    mutationFn: addPetVaccination,
  });
};

export const getPetVaccination = ({ data }: getRequest): Promise<getResponse> => {
  return axios.post(`parent/pet-vaccination/get`, data);
};

type UseGetVaccinationOptions = {
  config?: MutationConfig<typeof getPetVaccination>;
};

export const useGetPetVaccination = ({ config }: UseGetVaccinationOptions = {}) => {
  return useMutation({
    ...config,
    mutationFn: getPetVaccination,
  });
};

